// Utility condivise del modulo Gestione Accessi

const GIORNI = ["lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato", "domenica"];
const MESI = ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio",
  "agosto", "settembre", "ottobre", "novembre", "dicembre"];

export const dataItalianaLunga = (iso) => {
  if (!iso) return "";
  try {
    const d = new Date(String(iso).slice(0, 10) + "T00:00:00");
    const wd = (d.getDay() + 6) % 7; // lunedì=0
    return `${GIORNI[wd]} ${d.getDate()} ${MESI[d.getMonth()]} ${d.getFullYear()}`;
  } catch { return String(iso); }
};

export const oraDa = (iso) => (iso ? String(iso).slice(11, 16) : "");

export const STATI_AFFIL = ["attiva", "scaduta", "sospesa", "da_verificare"];

export const statoAffilBadge = (stato) => {
  switch (stato) {
    case "attiva":
      return { label: "Attiva", cls: "bg-[color:var(--brand-green-100)] text-[color:var(--brand-green-700)] border border-[color:var(--brand-green-600)]" };
    case "scaduta":
      return { label: "Scaduta", cls: "bg-[color:var(--brand-red-100)] text-[color:var(--brand-red-600)] border border-[color:var(--brand-red-600)]" };
    case "sospesa":
      return { label: "Sospesa", cls: "bg-[color:var(--brand-orange-100)] text-[color:var(--brand-orange-600)] border border-[color:var(--brand-orange-600)]" };
    default:
      return { label: "Da verificare", cls: "bg-slate-100 text-slate-600 border border-slate-300" };
  }
};

export const esitoAccessoBadge = (esito, annullato) => {
  if (annullato) return { label: "Annullato", cls: "bg-slate-100 text-slate-500 border border-slate-300 line-through" };
  if (esito === "confermato") return { label: "Confermato", cls: "bg-[color:var(--brand-green-100)] text-[color:var(--brand-green-700)] border border-[color:var(--brand-green-600)]" };
  if (esito === "sospeso") return { label: "Sospeso", cls: "bg-[color:var(--brand-orange-100)] text-[color:var(--brand-orange-600)] border border-[color:var(--brand-orange-600)]" };
  return { label: esito || "-", cls: "bg-slate-100 text-slate-600 border border-slate-300" };
};
